<template>
    <header class="header-global">
        <base-nav class="navbar-main" transparent type="" effect="light" expand>
            <router-link slot="brand" class="navbar-brand mr-lg-5" to="/">
                <img src="/img/brand/Marvelous.svg" alt="Logo Marvelous">
            </router-link>

            <div class="row" slot="content-header" slot-scope="{closeMenu}">
                <div class="col-6 collapse-brand" @click="goToHome()">
                    <h4>WeSaidSo</h4>
                </div>
                <div class="col-6 collapse-close">
                    <close-button @click="closeMenu"></close-button>
                </div>
            </div>

            <ul class="navbar-nav navbar-nav-hover align-items-lg-center">
                <base-dropdown class="nav-item" menu-classes="dropdown-menu-xl">
                    <a slot="title" href="#" class="nav-link" data-toggle="dropdown" role="button">
                        <i class="ni ni-ui-04 d-lg-none"></i>
                        <span class="nav-link-inner--text">{{ $t('nav.about') }}</span>
                    </a>
                    <div class="dropdown-menu-inner">
                        <router-link to="/about" class="media d-flex align-items-center">
                            <div class="icon icon-shape bg-gradient-warning rounded-circle text-white">
                                <i class="ni ni-spaceship"></i>
                            </div>
                            <div class="media-body ml-3">
                                <h5 class="heading text-primary mb-md-1">{{ $t('about.header') }}</h5>
                                <p class="description d-none d-md-inline-block mb-0">{{ $t('about.title') }}</p>
                            </div>
                        </router-link>
                        <router-link to="/resume" class="media d-flex align-items-center">
                            <div class="icon icon-shape bg-gradient-warning rounded-circle text-white">
                                <i class="ni ni-paper-diploma"></i>
                            </div>
                            <div class="media-body ml-3">
                                <h5 class="heading text-warning mb-md-1">{{ $t('resume.header') }}</h5>
                                <p class="description d-none d-md-inline-block mb-0">{{ $t('resume.title') }}</p>
                            </div>
                        </router-link>
                    </div>
                </base-dropdown>

                <base-dropdown class="nav-item" menu-classes="dropdown-menu-xl">
                    <a slot="title" href="/projects" class="nav-link" data-toggle="dropdown" role="button">
                        <i class="ni ni-ui-04 d-lg-none"></i>
                        <span class="nav-link-inner--text">{{ $t('nav.projects') }}</span>
                    </a>
                    <div class="dropdown-menu-inner">

                      <router-link v-for="project in projects" v-bind:key="project.id"
                        :to="'/project/' + project.slug" class="media d-flex align-items-center"
                      >
                        <div class="icon-logo icon icon-shape bg-gradient-warning rounded-circle text-white">
                          <img v-lazy="project.src"
                                class="rounded-circle img-center img-fluid shadow shadow-lg--hover">
                        </div>
                        <div class="media-body ml-3">
                          <h5 v-if="project.title" class="heading text-primary mb-md-1">{{ project.title }}</h5>
                          <p v-if="project.slug" class="description d-none d-md-inline-block mb-0">{{ $t('projects.' + project.slug + '.description') }}</p>
                        </div>
                      </router-link>
                    </div>
                </base-dropdown>
                <base-dropdown class="nav-item" menu-classes="dropdown-menu-xl">
                    <a slot="title" href="#" class="nav-link" data-toggle="dropdown" role="button">
                        <i class="ni ni-ui-04 d-lg-none"></i>
                        <span class="nav-link-inner--text">Workshops</span>
                    </a>
                    <div class="dropdown-menu-inner">
                      <router-link v-for="workshop in workshops" v-bind:key="workshop.id"
                        :to="'/workshop/' + workshop.slug" class="media d-flex align-items-center"
                      >
                        <div class="icon icon-shape bg-gradient-warning rounded-circle text-white">
                          <i :class="workshop.icon"></i>
                        </div>
                        <div class="media-body ml-3">
                          <h5 v-if="workshop.title" class="heading text-primary mb-md-1">{{ workshop.title }}</h5>
                          <p v-if="workshop.slug" class="description d-none d-md-inline-block mb-0">{{ $t('workshops.' + workshop.slug + '.description') }}</p>
                        </div>
                      </router-link>
                    </div>
                </base-dropdown>
                <!-- Remark for Frank: -->
                <!-- <li>
                  <router-link to="/workshops" class="nav-link">Workshops</router-link>
                </li> -->
                <li>
                  <router-link to="/contact" class="nav-link">Contact</router-link>
                </li>
            </ul>
            <ul class="navbar-nav align-items-lg-center ml-lg-auto">
                <li class="nav-item">
                    <a class="nav-link nav-link-icon" href="https://twitter.com/wesaidso" target="_blank" rel="noopener"
                       data-toggle="tooltip" title="Follow us on Twitter">
                        <i class="fa fa-twitter-square"></i>
                        <span class="nav-link-inner--text d-lg-none">Twitter</span>
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link nav-link-icon" href="https://www.linkedin.com/in/wesaidso/" target="_blank" rel="noopener"
                       data-toggle="tooltip" title="Connect on LinkdedIn">
                        <i class="fa fa-linkedin-square"></i>
                        <span class="nav-link-inner--text d-lg-none">LinkdedIn</span>
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link nav-link-icon" href="https://github.com/wesaidso"
                       target="_blank" rel="noopener" data-toggle="tooltip" title="Star us on Github">
                        <i class="fa fa-github"></i>
                        <span class="nav-link-inner--text d-lg-none">Github</span>
                    </a>
                </li>
                <!-- Contact button -->
                <!-- <li class="nav-item d-none d-lg-block ml-lg-4">
                    <a href="#" target="_blank" rel="noopener"
                       class="btn btn-neutral btn-icon">
                        <span class="btn-inner--icon">
                        <i class="fa fa-envelope mr-2"></i>
                        </span>
                        <span class="nav-link-inner--text">Start a conversation</span>
                    </a>
                </li> -->
                <LanguageSwitch class="nav-item d-none d-lg-block ml-lg-4" />
            </ul>
        </base-nav>
    </header>
</template>
<script>
import LanguageSwitch from "@/components/LanguageSwitch.vue";
import BaseNav from "@/components/BaseNav";
import BaseDropdown from "@/components/BaseDropdown";
import CloseButton from "@/components/CloseButton";

import projectsData from '@/data/projects.js';
import workshopsData from '@/data/workshops.js';

export default {
  components: {
    BaseNav,
    CloseButton,
    BaseDropdown,
    LanguageSwitch
  },
  data() {
    return {
      projects: projectsData,
      workshops: workshopsData
    }
  },
  methods: {
    goToHome() {
      if(this.$route.path !== '/') {
        this.$router.push({ path: '/' });
      }
    }
  }
};
</script>

<style lang="scss">
.icon-logo {
  padding: 3px;

  img {
    width: 36px;
  }
}
</style>
